import { useEffect, useEffectEvent } from 'react'

import { scrollTo } from '@app/utils/scrollTo'

import { useRouter } from '@app/packages/routing/RouterContext'

export const useScrollToHash = ({
  getOffset,
  element,
  timeout,
  getElement,
  onScroll,
}: {
  getOffset?: () => number
  element?: HTMLElement
  timeout?: number
  getElement?: (hash: string) => HTMLElement | null
  onScroll?: (element: HTMLElement) => void
} = {}) => {
  const router = useRouter()
  const hash = (router.location.hash ?? '').replace(/^#/, '')

  const scrollToHash = useEffectEvent(() => {
    if (!hash) return
    setTimeout(() => {
      try {
        const hashElement = getElement ? getElement(hash) : (element || document).querySelector<HTMLElement>('#' + hash) // can fail because hash may result in invalid selector
        if (hashElement) {
          const scrollOffset = getOffset?.() ?? 0
          void scrollTo(hashElement.getBoundingClientRect().top + window.scrollY - scrollOffset, 300).then(() => {
            onScroll?.(hashElement)
          })
        }
      } catch {}
    }, timeout || 0)
  })

  useEffect(() => {
    scrollToHash()
  }, [router.location.key, hash])
}
